import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class ActivityAdd extends Component{
	render(){
		const {activities} =this.props;
		let ac = _.find(activities.permissions, (o) => {return o==='Create'});
		return (
			ac ?
				<p>
					<NavLink to={`/proigualdad/actividades/crear`} className="button is-small is-inm-purple">{'Agregar Actividad'}</NavLink>
				</p>:''
		)
	}
}

export default SecureLayout(ActivityAdd);


// WEBPACK FOOTER //
// ./src/elements/activities/widget/activity_add.jsx